module.exports = __webpack_public_path__ + "static/media/logo_screenshot.1bbaebf8.png";